var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "#A0FF7E",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5.5a7 7 0 1 0 .001 14.001A7 7 0 0 0 7.5.5m3.023 4.714-3.29 4.563a.497.497 0 0 1-.808 0l-1.948-2.7a.125.125 0 0 1 .101-.199h.733c.16 0 .31.077.405.208L6.828 8.63l2.456-3.407a.5.5 0 0 1 .405-.207h.733c.101 0 .16.115.101.198"
  })));
};
export default SvgCheckCircle;